import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Dimension: any;
  HexColor: any;
  JSON: any;
  Quality: any;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']>;
  fileName: Maybe<Scalars['String']>;
  height: Maybe<Scalars['Int']>;
  linkedFrom: Maybe<AssetLinkingCollections>;
  size: Maybe<Scalars['Int']>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
  width: Maybe<Scalars['Int']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale: InputMaybe<Scalars['String']>;
  transform: InputMaybe<ImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AssetFilter = {
  AND: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType: InputMaybe<Scalars['String']>;
  contentType_contains: InputMaybe<Scalars['String']>;
  contentType_exists: InputMaybe<Scalars['Boolean']>;
  contentType_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentType_not: InputMaybe<Scalars['String']>;
  contentType_not_contains: InputMaybe<Scalars['String']>;
  contentType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']>;
  description_contains: InputMaybe<Scalars['String']>;
  description_exists: InputMaybe<Scalars['Boolean']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not: InputMaybe<Scalars['String']>;
  description_not_contains: InputMaybe<Scalars['String']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName: InputMaybe<Scalars['String']>;
  fileName_contains: InputMaybe<Scalars['String']>;
  fileName_exists: InputMaybe<Scalars['Boolean']>;
  fileName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName_not: InputMaybe<Scalars['String']>;
  fileName_not_contains: InputMaybe<Scalars['String']>;
  fileName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  height: InputMaybe<Scalars['Int']>;
  height_exists: InputMaybe<Scalars['Boolean']>;
  height_gt: InputMaybe<Scalars['Int']>;
  height_gte: InputMaybe<Scalars['Int']>;
  height_in: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  height_lt: InputMaybe<Scalars['Int']>;
  height_lte: InputMaybe<Scalars['Int']>;
  height_not: InputMaybe<Scalars['Int']>;
  height_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size: InputMaybe<Scalars['Int']>;
  size_exists: InputMaybe<Scalars['Boolean']>;
  size_gt: InputMaybe<Scalars['Int']>;
  size_gte: InputMaybe<Scalars['Int']>;
  size_in: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size_lt: InputMaybe<Scalars['Int']>;
  size_lte: InputMaybe<Scalars['Int']>;
  size_not: InputMaybe<Scalars['Int']>;
  size_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']>;
  title_contains: InputMaybe<Scalars['String']>;
  title_exists: InputMaybe<Scalars['Boolean']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not: InputMaybe<Scalars['String']>;
  title_not_contains: InputMaybe<Scalars['String']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url: InputMaybe<Scalars['String']>;
  url_contains: InputMaybe<Scalars['String']>;
  url_exists: InputMaybe<Scalars['Boolean']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not: InputMaybe<Scalars['String']>;
  url_not_contains: InputMaybe<Scalars['String']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  width: InputMaybe<Scalars['Int']>;
  width_exists: InputMaybe<Scalars['Boolean']>;
  width_gt: InputMaybe<Scalars['Int']>;
  width_gte: InputMaybe<Scalars['Int']>;
  width_in: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  width_lt: InputMaybe<Scalars['Int']>;
  width_lte: InputMaybe<Scalars['Int']>;
  width_not: InputMaybe<Scalars['Int']>;
  width_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/blip) */
export type Blip = Entry & {
  __typename?: 'Blip';
  capabilitiesCollection: Maybe<BlipCapabilitiesCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle: Maybe<Scalars['String']>;
  linkedFrom: Maybe<BlipLinkingCollections>;
  peopleCollection: Maybe<BlipPeopleCollection>;
  revisionsCollection: Maybe<BlipRevisionsCollection>;
  shortInfo: Maybe<Scalars['String']>;
  sys: Sys;
  tagsCollection: Maybe<BlipTagsCollection>;
  title: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/blip) */
export type BlipCapabilitiesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/blip) */
export type BlipInternalTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/blip) */
export type BlipLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/blip) */
export type BlipPeopleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/blip) */
export type BlipRevisionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/blip) */
export type BlipShortInfoArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/blip) */
export type BlipTagsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/blip) */
export type BlipTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type BlipCapabilitiesCollection = {
  __typename?: 'BlipCapabilitiesCollection';
  items: Array<Maybe<Capability>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BlipCollection = {
  __typename?: 'BlipCollection';
  items: Array<Maybe<Blip>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BlipFilter = {
  AND: InputMaybe<Array<InputMaybe<BlipFilter>>>;
  OR: InputMaybe<Array<InputMaybe<BlipFilter>>>;
  capabilities: InputMaybe<CfCapabilityNestedFilter>;
  capabilitiesCollection_exists: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalTitle: InputMaybe<Scalars['String']>;
  internalTitle_contains: InputMaybe<Scalars['String']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not: InputMaybe<Scalars['String']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  people: InputMaybe<CfPersonNestedFilter>;
  peopleCollection_exists: InputMaybe<Scalars['Boolean']>;
  revisions: InputMaybe<CfRevisionNestedFilter>;
  revisionsCollection_exists: InputMaybe<Scalars['Boolean']>;
  shortInfo: InputMaybe<Scalars['String']>;
  shortInfo_contains: InputMaybe<Scalars['String']>;
  shortInfo_exists: InputMaybe<Scalars['Boolean']>;
  shortInfo_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortInfo_not: InputMaybe<Scalars['String']>;
  shortInfo_not_contains: InputMaybe<Scalars['String']>;
  shortInfo_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
  tags: InputMaybe<CfFilterTagNestedFilter>;
  tagsCollection_exists: InputMaybe<Scalars['Boolean']>;
  title: InputMaybe<Scalars['String']>;
  title_contains: InputMaybe<Scalars['String']>;
  title_exists: InputMaybe<Scalars['Boolean']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not: InputMaybe<Scalars['String']>;
  title_not_contains: InputMaybe<Scalars['String']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BlipLinkingCollections = {
  __typename?: 'BlipLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  quadrantCollection: Maybe<QuadrantCollection>;
};


export type BlipLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BlipLinkingCollectionsQuadrantCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum BlipOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShortInfoAsc = 'shortInfo_ASC',
  ShortInfoDesc = 'shortInfo_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BlipPeopleCollection = {
  __typename?: 'BlipPeopleCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BlipRevisionsCollection = {
  __typename?: 'BlipRevisionsCollection';
  items: Array<Maybe<Revision>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BlipTagsCollection = {
  __typename?: 'BlipTagsCollection';
  items: Array<Maybe<FilterTag>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/capability) */
export type Capability = Entry & {
  __typename?: 'Capability';
  contentfulMetadata: ContentfulMetadata;
  internalName: Maybe<Scalars['String']>;
  linkedFrom: Maybe<CapabilityLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/capability) */
export type CapabilityInternalNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/capability) */
export type CapabilityLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/capability) */
export type CapabilityTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type CapabilityCollection = {
  __typename?: 'CapabilityCollection';
  items: Array<Maybe<Capability>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CapabilityFilter = {
  AND: InputMaybe<Array<InputMaybe<CapabilityFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CapabilityFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']>;
  title_contains: InputMaybe<Scalars['String']>;
  title_exists: InputMaybe<Scalars['Boolean']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not: InputMaybe<Scalars['String']>;
  title_not_contains: InputMaybe<Scalars['String']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CapabilityLinkingCollections = {
  __typename?: 'CapabilityLinkingCollections';
  blipCollection: Maybe<BlipCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type CapabilityLinkingCollectionsBlipCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CapabilityLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CapabilityOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataFilter = {
  tags: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists: InputMaybe<Scalars['Boolean']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *     Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type EntryFilter = {
  AND: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/filterTag) */
export type FilterTag = Entry & {
  __typename?: 'FilterTag';
  contentfulMetadata: ContentfulMetadata;
  internalName: Maybe<Scalars['String']>;
  linkedFrom: Maybe<FilterTagLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/filterTag) */
export type FilterTagInternalNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/filterTag) */
export type FilterTagLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/filterTag) */
export type FilterTagTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type FilterTagCollection = {
  __typename?: 'FilterTagCollection';
  items: Array<Maybe<FilterTag>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type FilterTagFilter = {
  AND: InputMaybe<Array<InputMaybe<FilterTagFilter>>>;
  OR: InputMaybe<Array<InputMaybe<FilterTagFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']>;
  title_contains: InputMaybe<Scalars['String']>;
  title_exists: InputMaybe<Scalars['Boolean']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not: InputMaybe<Scalars['String']>;
  title_not_contains: InputMaybe<Scalars['String']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FilterTagLinkingCollections = {
  __typename?: 'FilterTagLinkingCollections';
  blipCollection: Maybe<BlipCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type FilterTagLinkingCollectionsBlipCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FilterTagLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum FilterTagOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ImageFormat {
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor: InputMaybe<Scalars['HexColor']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius: InputMaybe<Scalars['Int']>;
  /** Desired image format. Defaults to the original image format. */
  format: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height: InputMaybe<Scalars['Dimension']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality: InputMaybe<Scalars['Quality']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width: InputMaybe<Scalars['Dimension']>;
};

/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/person) */
export type Person = Entry & {
  __typename?: 'Person';
  contentfulMetadata: ContentfulMetadata;
  email: Maybe<Scalars['String']>;
  internalName: Maybe<Scalars['String']>;
  linkedFrom: Maybe<PersonLinkingCollections>;
  name: Maybe<Scalars['String']>;
  position: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/person) */
export type PersonEmailArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/person) */
export type PersonInternalNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/person) */
export type PersonLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/person) */
export type PersonNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/person) */
export type PersonPositionArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type PersonCollection = {
  __typename?: 'PersonCollection';
  items: Array<Maybe<Person>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type PersonFilter = {
  AND: InputMaybe<Array<InputMaybe<PersonFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PersonFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  email: InputMaybe<Scalars['String']>;
  email_contains: InputMaybe<Scalars['String']>;
  email_exists: InputMaybe<Scalars['Boolean']>;
  email_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email_not: InputMaybe<Scalars['String']>;
  email_not_contains: InputMaybe<Scalars['String']>;
  email_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: InputMaybe<Scalars['String']>;
  name_contains: InputMaybe<Scalars['String']>;
  name_exists: InputMaybe<Scalars['Boolean']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not: InputMaybe<Scalars['String']>;
  name_not_contains: InputMaybe<Scalars['String']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  position: InputMaybe<Scalars['String']>;
  position_contains: InputMaybe<Scalars['String']>;
  position_exists: InputMaybe<Scalars['Boolean']>;
  position_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  position_not: InputMaybe<Scalars['String']>;
  position_not_contains: InputMaybe<Scalars['String']>;
  position_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
};

export type PersonLinkingCollections = {
  __typename?: 'PersonLinkingCollections';
  blipCollection: Maybe<BlipCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type PersonLinkingCollectionsBlipCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PersonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum PersonOrder {
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/quadrant) */
export type Quadrant = Entry & {
  __typename?: 'Quadrant';
  blipListCollection: Maybe<QuadrantBlipListCollection>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<QuadrantDescription>;
  internalName: Maybe<Scalars['String']>;
  linkedFrom: Maybe<QuadrantLinkingCollections>;
  name: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/quadrant) */
export type QuadrantBlipListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/quadrant) */
export type QuadrantDescriptionArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/quadrant) */
export type QuadrantInternalNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/quadrant) */
export type QuadrantLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/quadrant) */
export type QuadrantNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type QuadrantBlipListCollection = {
  __typename?: 'QuadrantBlipListCollection';
  items: Array<Maybe<Blip>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type QuadrantCollection = {
  __typename?: 'QuadrantCollection';
  items: Array<Maybe<Quadrant>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type QuadrantDescription = {
  __typename?: 'QuadrantDescription';
  json: Scalars['JSON'];
  links: QuadrantDescriptionLinks;
};

export type QuadrantDescriptionAssets = {
  __typename?: 'QuadrantDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type QuadrantDescriptionEntries = {
  __typename?: 'QuadrantDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type QuadrantDescriptionLinks = {
  __typename?: 'QuadrantDescriptionLinks';
  assets: QuadrantDescriptionAssets;
  entries: QuadrantDescriptionEntries;
};

export type QuadrantFilter = {
  AND: InputMaybe<Array<InputMaybe<QuadrantFilter>>>;
  OR: InputMaybe<Array<InputMaybe<QuadrantFilter>>>;
  blipList: InputMaybe<CfBlipNestedFilter>;
  blipListCollection_exists: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description_contains: InputMaybe<Scalars['String']>;
  description_exists: InputMaybe<Scalars['Boolean']>;
  description_not_contains: InputMaybe<Scalars['String']>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: InputMaybe<Scalars['String']>;
  name_contains: InputMaybe<Scalars['String']>;
  name_exists: InputMaybe<Scalars['Boolean']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not: InputMaybe<Scalars['String']>;
  name_not_contains: InputMaybe<Scalars['String']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
};

export type QuadrantLinkingCollections = {
  __typename?: 'QuadrantLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  radarCollection: Maybe<RadarCollection>;
};


export type QuadrantLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuadrantLinkingCollectionsRadarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum QuadrantOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Query = {
  __typename?: 'Query';
  asset: Maybe<Asset>;
  assetCollection: Maybe<AssetCollection>;
  blip: Maybe<Blip>;
  blipCollection: Maybe<BlipCollection>;
  capability: Maybe<Capability>;
  capabilityCollection: Maybe<CapabilityCollection>;
  entryCollection: Maybe<EntryCollection>;
  filterTag: Maybe<FilterTag>;
  filterTagCollection: Maybe<FilterTagCollection>;
  person: Maybe<Person>;
  personCollection: Maybe<PersonCollection>;
  quadrant: Maybe<Quadrant>;
  quadrantCollection: Maybe<QuadrantCollection>;
  radar: Maybe<Radar>;
  radarCollection: Maybe<RadarCollection>;
  revision: Maybe<Revision>;
  revisionCollection: Maybe<RevisionCollection>;
  ring: Maybe<Ring>;
  ringCollection: Maybe<RingCollection>;
};


export type QueryAssetArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<AssetFilter>;
};


export type QueryBlipArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryBlipCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<BlipOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<BlipFilter>;
};


export type QueryCapabilityArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryCapabilityCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<CapabilityOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<CapabilityFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<EntryFilter>;
};


export type QueryFilterTagArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryFilterTagCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<FilterTagOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<FilterTagFilter>;
};


export type QueryPersonArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryPersonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<PersonOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<PersonFilter>;
};


export type QueryQuadrantArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryQuadrantCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<QuadrantOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<QuadrantFilter>;
};


export type QueryRadarArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryRadarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<RadarOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RadarFilter>;
};


export type QueryRevisionArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryRevisionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<RevisionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RevisionFilter>;
};


export type QueryRingArgs = {
  id: Scalars['String'];
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


export type QueryRingCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  order: InputMaybe<Array<InputMaybe<RingOrder>>>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where: InputMaybe<RingFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/radar) */
export type Radar = Entry & {
  __typename?: 'Radar';
  aboutText: Maybe<RadarAboutText>;
  aboutTitle: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  internalName: Maybe<Scalars['String']>;
  linkedFrom: Maybe<RadarLinkingCollections>;
  quadrant1: Maybe<Quadrant>;
  quadrant2: Maybe<Quadrant>;
  quadrant3: Maybe<Quadrant>;
  quadrant4: Maybe<Quadrant>;
  slug: Maybe<Scalars['String']>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/radar) */
export type RadarAboutTextArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/radar) */
export type RadarAboutTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/radar) */
export type RadarInternalNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/radar) */
export type RadarLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/radar) */
export type RadarQuadrant1Args = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/radar) */
export type RadarQuadrant2Args = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/radar) */
export type RadarQuadrant3Args = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/radar) */
export type RadarQuadrant4Args = {
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/radar) */
export type RadarSlugArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/radar) */
export type RadarTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type RadarAboutText = {
  __typename?: 'RadarAboutText';
  json: Scalars['JSON'];
  links: RadarAboutTextLinks;
};

export type RadarAboutTextAssets = {
  __typename?: 'RadarAboutTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type RadarAboutTextEntries = {
  __typename?: 'RadarAboutTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type RadarAboutTextLinks = {
  __typename?: 'RadarAboutTextLinks';
  assets: RadarAboutTextAssets;
  entries: RadarAboutTextEntries;
};

export type RadarCollection = {
  __typename?: 'RadarCollection';
  items: Array<Maybe<Radar>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type RadarFilter = {
  AND: InputMaybe<Array<InputMaybe<RadarFilter>>>;
  OR: InputMaybe<Array<InputMaybe<RadarFilter>>>;
  aboutText_contains: InputMaybe<Scalars['String']>;
  aboutText_exists: InputMaybe<Scalars['Boolean']>;
  aboutText_not_contains: InputMaybe<Scalars['String']>;
  aboutTitle: InputMaybe<Scalars['String']>;
  aboutTitle_contains: InputMaybe<Scalars['String']>;
  aboutTitle_exists: InputMaybe<Scalars['Boolean']>;
  aboutTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  aboutTitle_not: InputMaybe<Scalars['String']>;
  aboutTitle_not_contains: InputMaybe<Scalars['String']>;
  aboutTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quadrant1: InputMaybe<CfQuadrantNestedFilter>;
  quadrant1_exists: InputMaybe<Scalars['Boolean']>;
  quadrant2: InputMaybe<CfQuadrantNestedFilter>;
  quadrant2_exists: InputMaybe<Scalars['Boolean']>;
  quadrant3: InputMaybe<CfQuadrantNestedFilter>;
  quadrant3_exists: InputMaybe<Scalars['Boolean']>;
  quadrant4: InputMaybe<CfQuadrantNestedFilter>;
  quadrant4_exists: InputMaybe<Scalars['Boolean']>;
  slug: InputMaybe<Scalars['String']>;
  slug_contains: InputMaybe<Scalars['String']>;
  slug_exists: InputMaybe<Scalars['Boolean']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not: InputMaybe<Scalars['String']>;
  slug_not_contains: InputMaybe<Scalars['String']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']>;
  title_contains: InputMaybe<Scalars['String']>;
  title_exists: InputMaybe<Scalars['Boolean']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not: InputMaybe<Scalars['String']>;
  title_not_contains: InputMaybe<Scalars['String']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RadarLinkingCollections = {
  __typename?: 'RadarLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
};


export type RadarLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum RadarOrder {
  AboutTitleAsc = 'aboutTitle_ASC',
  AboutTitleDesc = 'aboutTitle_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/revision) */
export type Revision = Entry & {
  __typename?: 'Revision';
  contentfulMetadata: ContentfulMetadata;
  date: Maybe<Scalars['DateTime']>;
  internalName: Maybe<Scalars['String']>;
  linkedFrom: Maybe<RevisionLinkingCollections>;
  ring: Maybe<Scalars['String']>;
  sys: Sys;
  update: Maybe<RevisionUpdate>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/revision) */
export type RevisionDateArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/revision) */
export type RevisionInternalNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/revision) */
export type RevisionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/revision) */
export type RevisionRingArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/revision) */
export type RevisionUpdateArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type RevisionCollection = {
  __typename?: 'RevisionCollection';
  items: Array<Maybe<Revision>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type RevisionFilter = {
  AND: InputMaybe<Array<InputMaybe<RevisionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<RevisionFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']>;
  date_exists: InputMaybe<Scalars['Boolean']>;
  date_gt: InputMaybe<Scalars['DateTime']>;
  date_gte: InputMaybe<Scalars['DateTime']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  date_lt: InputMaybe<Scalars['DateTime']>;
  date_lte: InputMaybe<Scalars['DateTime']>;
  date_not: InputMaybe<Scalars['DateTime']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ring: InputMaybe<Scalars['String']>;
  ring_contains: InputMaybe<Scalars['String']>;
  ring_exists: InputMaybe<Scalars['Boolean']>;
  ring_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ring_not: InputMaybe<Scalars['String']>;
  ring_not_contains: InputMaybe<Scalars['String']>;
  ring_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
  update_contains: InputMaybe<Scalars['String']>;
  update_exists: InputMaybe<Scalars['Boolean']>;
  update_not_contains: InputMaybe<Scalars['String']>;
};

export type RevisionLinkingCollections = {
  __typename?: 'RevisionLinkingCollections';
  blipCollection: Maybe<BlipCollection>;
  entryCollection: Maybe<EntryCollection>;
};


export type RevisionLinkingCollectionsBlipCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type RevisionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum RevisionOrder {
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  RingAsc = 'ring_ASC',
  RingDesc = 'ring_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type RevisionUpdate = {
  __typename?: 'RevisionUpdate';
  json: Scalars['JSON'];
  links: RevisionUpdateLinks;
};

export type RevisionUpdateAssets = {
  __typename?: 'RevisionUpdateAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type RevisionUpdateEntries = {
  __typename?: 'RevisionUpdateEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type RevisionUpdateLinks = {
  __typename?: 'RevisionUpdateLinks';
  assets: RevisionUpdateAssets;
  entries: RevisionUpdateEntries;
};

/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/ring) */
export type Ring = Entry & {
  __typename?: 'Ring';
  contentfulMetadata: ContentfulMetadata;
  internalName: Maybe<Scalars['String']>;
  linkedFrom: Maybe<RingLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/ring) */
export type RingInternalNameArgs = {
  locale: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/ring) */
export type RingLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/0tq83xj8km83/content_types/ring) */
export type RingTitleArgs = {
  locale: InputMaybe<Scalars['String']>;
};

export type RingCollection = {
  __typename?: 'RingCollection';
  items: Array<Maybe<Ring>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type RingFilter = {
  AND: InputMaybe<Array<InputMaybe<RingFilter>>>;
  OR: InputMaybe<Array<InputMaybe<RingFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']>;
  title_contains: InputMaybe<Scalars['String']>;
  title_exists: InputMaybe<Scalars['Boolean']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not: InputMaybe<Scalars['String']>;
  title_not_contains: InputMaybe<Scalars['String']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RingLinkingCollections = {
  __typename?: 'RingLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
};


export type RingLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale: InputMaybe<Scalars['String']>;
  preview: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum RingOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String'];
  firstPublishedAt: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  publishedAt: Maybe<Scalars['DateTime']>;
  publishedVersion: Maybe<Scalars['Int']>;
  spaceId: Scalars['String'];
};

export type SysFilter = {
  firstPublishedAt: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_exists: InputMaybe<Scalars['Boolean']>;
  firstPublishedAt_gt: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_gte: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  firstPublishedAt_lt: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_lte: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  id: InputMaybe<Scalars['String']>;
  id_contains: InputMaybe<Scalars['String']>;
  id_exists: InputMaybe<Scalars['Boolean']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not: InputMaybe<Scalars['String']>;
  id_not_contains: InputMaybe<Scalars['String']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAt: InputMaybe<Scalars['DateTime']>;
  publishedAt_exists: InputMaybe<Scalars['Boolean']>;
  publishedAt_gt: InputMaybe<Scalars['DateTime']>;
  publishedAt_gte: InputMaybe<Scalars['DateTime']>;
  publishedAt_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt_lt: InputMaybe<Scalars['DateTime']>;
  publishedAt_lte: InputMaybe<Scalars['DateTime']>;
  publishedAt_not: InputMaybe<Scalars['DateTime']>;
  publishedAt_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedVersion: InputMaybe<Scalars['Float']>;
  publishedVersion_exists: InputMaybe<Scalars['Boolean']>;
  publishedVersion_gt: InputMaybe<Scalars['Float']>;
  publishedVersion_gte: InputMaybe<Scalars['Float']>;
  publishedVersion_in: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  publishedVersion_lt: InputMaybe<Scalars['Float']>;
  publishedVersion_lte: InputMaybe<Scalars['Float']>;
  publishedVersion_not: InputMaybe<Scalars['Float']>;
  publishedVersion_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type CfBlipNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfBlipNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfBlipNestedFilter>>>;
  capabilitiesCollection_exists: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalTitle: InputMaybe<Scalars['String']>;
  internalTitle_contains: InputMaybe<Scalars['String']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not: InputMaybe<Scalars['String']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  peopleCollection_exists: InputMaybe<Scalars['Boolean']>;
  revisionsCollection_exists: InputMaybe<Scalars['Boolean']>;
  shortInfo: InputMaybe<Scalars['String']>;
  shortInfo_contains: InputMaybe<Scalars['String']>;
  shortInfo_exists: InputMaybe<Scalars['Boolean']>;
  shortInfo_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shortInfo_not: InputMaybe<Scalars['String']>;
  shortInfo_not_contains: InputMaybe<Scalars['String']>;
  shortInfo_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
  tagsCollection_exists: InputMaybe<Scalars['Boolean']>;
  title: InputMaybe<Scalars['String']>;
  title_contains: InputMaybe<Scalars['String']>;
  title_exists: InputMaybe<Scalars['Boolean']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not: InputMaybe<Scalars['String']>;
  title_not_contains: InputMaybe<Scalars['String']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfCapabilityNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfCapabilityNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfCapabilityNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']>;
  title_contains: InputMaybe<Scalars['String']>;
  title_exists: InputMaybe<Scalars['Boolean']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not: InputMaybe<Scalars['String']>;
  title_not_contains: InputMaybe<Scalars['String']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfFilterTagNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfFilterTagNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfFilterTagNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']>;
  title_contains: InputMaybe<Scalars['String']>;
  title_exists: InputMaybe<Scalars['Boolean']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not: InputMaybe<Scalars['String']>;
  title_not_contains: InputMaybe<Scalars['String']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfPersonNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfPersonNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfPersonNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  email: InputMaybe<Scalars['String']>;
  email_contains: InputMaybe<Scalars['String']>;
  email_exists: InputMaybe<Scalars['Boolean']>;
  email_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email_not: InputMaybe<Scalars['String']>;
  email_not_contains: InputMaybe<Scalars['String']>;
  email_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: InputMaybe<Scalars['String']>;
  name_contains: InputMaybe<Scalars['String']>;
  name_exists: InputMaybe<Scalars['Boolean']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not: InputMaybe<Scalars['String']>;
  name_not_contains: InputMaybe<Scalars['String']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  position: InputMaybe<Scalars['String']>;
  position_contains: InputMaybe<Scalars['String']>;
  position_exists: InputMaybe<Scalars['Boolean']>;
  position_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  position_not: InputMaybe<Scalars['String']>;
  position_not_contains: InputMaybe<Scalars['String']>;
  position_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfQuadrantNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfQuadrantNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfQuadrantNestedFilter>>>;
  blipListCollection_exists: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description_contains: InputMaybe<Scalars['String']>;
  description_exists: InputMaybe<Scalars['Boolean']>;
  description_not_contains: InputMaybe<Scalars['String']>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: InputMaybe<Scalars['String']>;
  name_contains: InputMaybe<Scalars['String']>;
  name_exists: InputMaybe<Scalars['Boolean']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not: InputMaybe<Scalars['String']>;
  name_not_contains: InputMaybe<Scalars['String']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfRevisionNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfRevisionNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfRevisionNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']>;
  date_exists: InputMaybe<Scalars['Boolean']>;
  date_gt: InputMaybe<Scalars['DateTime']>;
  date_gte: InputMaybe<Scalars['DateTime']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  date_lt: InputMaybe<Scalars['DateTime']>;
  date_lte: InputMaybe<Scalars['DateTime']>;
  date_not: InputMaybe<Scalars['DateTime']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  internalName: InputMaybe<Scalars['String']>;
  internalName_contains: InputMaybe<Scalars['String']>;
  internalName_exists: InputMaybe<Scalars['Boolean']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName_not: InputMaybe<Scalars['String']>;
  internalName_not_contains: InputMaybe<Scalars['String']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ring: InputMaybe<Scalars['String']>;
  ring_contains: InputMaybe<Scalars['String']>;
  ring_exists: InputMaybe<Scalars['Boolean']>;
  ring_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ring_not: InputMaybe<Scalars['String']>;
  ring_not_contains: InputMaybe<Scalars['String']>;
  ring_not_in: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys: InputMaybe<SysFilter>;
  update_contains: InputMaybe<Scalars['String']>;
  update_exists: InputMaybe<Scalars['Boolean']>;
  update_not_contains: InputMaybe<Scalars['String']>;
};

type BaseEntryFields_Blip_Fragment = { __typename: 'Blip', sys: { __typename?: 'Sys', id: string } };

type BaseEntryFields_Capability_Fragment = { __typename: 'Capability', sys: { __typename?: 'Sys', id: string } };

type BaseEntryFields_FilterTag_Fragment = { __typename: 'FilterTag', sys: { __typename?: 'Sys', id: string } };

type BaseEntryFields_Person_Fragment = { __typename: 'Person', sys: { __typename?: 'Sys', id: string } };

type BaseEntryFields_Quadrant_Fragment = { __typename: 'Quadrant', sys: { __typename?: 'Sys', id: string } };

type BaseEntryFields_Radar_Fragment = { __typename: 'Radar', sys: { __typename?: 'Sys', id: string } };

type BaseEntryFields_Revision_Fragment = { __typename: 'Revision', sys: { __typename?: 'Sys', id: string } };

type BaseEntryFields_Ring_Fragment = { __typename: 'Ring', sys: { __typename?: 'Sys', id: string } };

export type BaseEntryFieldsFragment = BaseEntryFields_Blip_Fragment | BaseEntryFields_Capability_Fragment | BaseEntryFields_FilterTag_Fragment | BaseEntryFields_Person_Fragment | BaseEntryFields_Quadrant_Fragment | BaseEntryFields_Radar_Fragment | BaseEntryFields_Revision_Fragment | BaseEntryFields_Ring_Fragment;

export type BlipFieldsFragment = { __typename?: 'Blip', title: string | null | undefined, shortInfo: string | null | undefined, peopleCollection: { __typename?: 'BlipPeopleCollection', total: number, items: Array<{ __typename?: 'Person', name: string | null | undefined, email: string | null | undefined } | null | undefined> } | null | undefined, tagsCollection: { __typename?: 'BlipTagsCollection', total: number, items: Array<{ __typename?: 'FilterTag', title: string | null | undefined } | null | undefined> } | null | undefined, capabilitiesCollection: { __typename?: 'BlipCapabilitiesCollection', total: number, items: Array<{ __typename?: 'Capability', title: string | null | undefined } | null | undefined> } | null | undefined, revisionsCollection: { __typename?: 'BlipRevisionsCollection', total: number, items: Array<{ __typename?: 'Revision', date: any | null | undefined, ring: string | null | undefined, update: { __typename?: 'RevisionUpdate', json: any } | null | undefined } | null | undefined> } | null | undefined };

export type CapabilityFieldsFragment = { __typename?: 'Capability', title: string | null | undefined };

export type FilterTagFieldsFragment = { __typename?: 'FilterTag', title: string | null | undefined };

export type PersonFieldsFragment = { __typename?: 'Person', name: string | null | undefined, email: string | null | undefined };

export type QuadrantFieldsFragment = { __typename?: 'Quadrant', name: string | null | undefined, description: { __typename?: 'QuadrantDescription', json: any } | null | undefined, blipListCollection: { __typename?: 'QuadrantBlipListCollection', total: number, items: Array<{ __typename?: 'Blip', title: string | null | undefined, shortInfo: string | null | undefined, peopleCollection: { __typename?: 'BlipPeopleCollection', total: number, items: Array<{ __typename?: 'Person', name: string | null | undefined, email: string | null | undefined } | null | undefined> } | null | undefined, tagsCollection: { __typename?: 'BlipTagsCollection', total: number, items: Array<{ __typename?: 'FilterTag', title: string | null | undefined } | null | undefined> } | null | undefined, capabilitiesCollection: { __typename?: 'BlipCapabilitiesCollection', total: number, items: Array<{ __typename?: 'Capability', title: string | null | undefined } | null | undefined> } | null | undefined, revisionsCollection: { __typename?: 'BlipRevisionsCollection', total: number, items: Array<{ __typename?: 'Revision', date: any | null | undefined, ring: string | null | undefined, update: { __typename?: 'RevisionUpdate', json: any } | null | undefined } | null | undefined> } | null | undefined } | null | undefined> } | null | undefined };

export type RevisionFieldsFragment = { __typename?: 'Revision', date: any | null | undefined, ring: string | null | undefined, update: { __typename?: 'RevisionUpdate', json: any } | null | undefined };

export type RingFieldsFragment = { __typename?: 'Ring', title: string | null | undefined };

export type GetAllRadarQueryVariables = Exact<{
  preview: Scalars['Boolean'];
}>;


export type GetAllRadarQuery = { __typename?: 'Query', pages: { __typename?: 'RadarCollection', total: number, items: Array<{ __typename?: 'Radar', title: string | null | undefined, slug: string | null | undefined } | null | undefined> } | null | undefined };

export type GetRadarQueryVariables = Exact<{
  preview: Scalars['Boolean'];
  slug: Scalars['String'];
}>;


export type GetRadarQuery = { __typename?: 'Query', pages: { __typename?: 'RadarCollection', total: number, items: Array<{ __typename?: 'Radar', title: string | null | undefined, quadrant1: { __typename?: 'Quadrant', name: string | null | undefined, description: { __typename?: 'QuadrantDescription', json: any } | null | undefined, blipListCollection: { __typename?: 'QuadrantBlipListCollection', total: number, items: Array<{ __typename?: 'Blip', title: string | null | undefined, shortInfo: string | null | undefined, peopleCollection: { __typename?: 'BlipPeopleCollection', total: number, items: Array<{ __typename?: 'Person', name: string | null | undefined, email: string | null | undefined } | null | undefined> } | null | undefined, tagsCollection: { __typename?: 'BlipTagsCollection', total: number, items: Array<{ __typename?: 'FilterTag', title: string | null | undefined } | null | undefined> } | null | undefined, capabilitiesCollection: { __typename?: 'BlipCapabilitiesCollection', total: number, items: Array<{ __typename?: 'Capability', title: string | null | undefined } | null | undefined> } | null | undefined, revisionsCollection: { __typename?: 'BlipRevisionsCollection', total: number, items: Array<{ __typename?: 'Revision', date: any | null | undefined, ring: string | null | undefined, update: { __typename?: 'RevisionUpdate', json: any } | null | undefined } | null | undefined> } | null | undefined } | null | undefined> } | null | undefined } | null | undefined, quadrant2: { __typename?: 'Quadrant', name: string | null | undefined, description: { __typename?: 'QuadrantDescription', json: any } | null | undefined, blipListCollection: { __typename?: 'QuadrantBlipListCollection', total: number, items: Array<{ __typename?: 'Blip', title: string | null | undefined, shortInfo: string | null | undefined, peopleCollection: { __typename?: 'BlipPeopleCollection', total: number, items: Array<{ __typename?: 'Person', name: string | null | undefined, email: string | null | undefined } | null | undefined> } | null | undefined, tagsCollection: { __typename?: 'BlipTagsCollection', total: number, items: Array<{ __typename?: 'FilterTag', title: string | null | undefined } | null | undefined> } | null | undefined, capabilitiesCollection: { __typename?: 'BlipCapabilitiesCollection', total: number, items: Array<{ __typename?: 'Capability', title: string | null | undefined } | null | undefined> } | null | undefined, revisionsCollection: { __typename?: 'BlipRevisionsCollection', total: number, items: Array<{ __typename?: 'Revision', date: any | null | undefined, ring: string | null | undefined, update: { __typename?: 'RevisionUpdate', json: any } | null | undefined } | null | undefined> } | null | undefined } | null | undefined> } | null | undefined } | null | undefined, quadrant3: { __typename?: 'Quadrant', name: string | null | undefined, description: { __typename?: 'QuadrantDescription', json: any } | null | undefined, blipListCollection: { __typename?: 'QuadrantBlipListCollection', total: number, items: Array<{ __typename?: 'Blip', title: string | null | undefined, shortInfo: string | null | undefined, peopleCollection: { __typename?: 'BlipPeopleCollection', total: number, items: Array<{ __typename?: 'Person', name: string | null | undefined, email: string | null | undefined } | null | undefined> } | null | undefined, tagsCollection: { __typename?: 'BlipTagsCollection', total: number, items: Array<{ __typename?: 'FilterTag', title: string | null | undefined } | null | undefined> } | null | undefined, capabilitiesCollection: { __typename?: 'BlipCapabilitiesCollection', total: number, items: Array<{ __typename?: 'Capability', title: string | null | undefined } | null | undefined> } | null | undefined, revisionsCollection: { __typename?: 'BlipRevisionsCollection', total: number, items: Array<{ __typename?: 'Revision', date: any | null | undefined, ring: string | null | undefined, update: { __typename?: 'RevisionUpdate', json: any } | null | undefined } | null | undefined> } | null | undefined } | null | undefined> } | null | undefined } | null | undefined, quadrant4: { __typename?: 'Quadrant', name: string | null | undefined, description: { __typename?: 'QuadrantDescription', json: any } | null | undefined, blipListCollection: { __typename?: 'QuadrantBlipListCollection', total: number, items: Array<{ __typename?: 'Blip', title: string | null | undefined, shortInfo: string | null | undefined, peopleCollection: { __typename?: 'BlipPeopleCollection', total: number, items: Array<{ __typename?: 'Person', name: string | null | undefined, email: string | null | undefined } | null | undefined> } | null | undefined, tagsCollection: { __typename?: 'BlipTagsCollection', total: number, items: Array<{ __typename?: 'FilterTag', title: string | null | undefined } | null | undefined> } | null | undefined, capabilitiesCollection: { __typename?: 'BlipCapabilitiesCollection', total: number, items: Array<{ __typename?: 'Capability', title: string | null | undefined } | null | undefined> } | null | undefined, revisionsCollection: { __typename?: 'BlipRevisionsCollection', total: number, items: Array<{ __typename?: 'Revision', date: any | null | undefined, ring: string | null | undefined, update: { __typename?: 'RevisionUpdate', json: any } | null | undefined } | null | undefined> } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export const BaseEntryFieldsFragmentDoc = `
    fragment baseEntryFields on Entry {
  __typename
  sys {
    id
  }
}
    `;
export const PersonFieldsFragmentDoc = `
    fragment personFields on Person {
  name
  email
}
    `;
export const FilterTagFieldsFragmentDoc = `
    fragment filterTagFields on FilterTag {
  title
}
    `;
export const CapabilityFieldsFragmentDoc = `
    fragment capabilityFields on Capability {
  title
}
    `;
export const RevisionFieldsFragmentDoc = `
    fragment revisionFields on Revision {
  date
  ring
  update {
    json
  }
}
    `;
export const BlipFieldsFragmentDoc = `
    fragment blipFields on Blip {
  title
  shortInfo
  peopleCollection(limit: 2) {
    total
    items {
      ... on Person {
        ...personFields
      }
    }
  }
  tagsCollection(limit: 5) {
    total
    items {
      ... on FilterTag {
        ...filterTagFields
      }
    }
  }
  capabilitiesCollection(limit: 5) {
    total
    items {
      ... on Capability {
        ...capabilityFields
      }
    }
  }
  revisionsCollection(limit: 5) {
    total
    items {
      ... on Revision {
        ...revisionFields
      }
    }
  }
}
    `;
export const QuadrantFieldsFragmentDoc = `
    fragment quadrantFields on Quadrant {
  name
  description {
    json
  }
  blipListCollection(limit: 150) {
    total
    items {
      ... on Blip {
        ...blipFields
      }
    }
  }
}
    `;
export const RingFieldsFragmentDoc = `
    fragment ringFields on Ring {
  title
}
    `;
export const GetAllRadarDocument = `
    query getAllRadar($preview: Boolean!) {
  pages: radarCollection(preview: $preview) {
    total
    items {
      title
      slug
    }
  }
}
    `;
export const useGetAllRadarQuery = <
      TData = GetAllRadarQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllRadarQueryVariables,
      options?: UseQueryOptions<GetAllRadarQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllRadarQuery, TError, TData>(
      ['getAllRadar', variables],
      fetcher<GetAllRadarQuery, GetAllRadarQueryVariables>(client, GetAllRadarDocument, variables, headers),
      options
    );

useGetAllRadarQuery.getKey = (variables: GetAllRadarQueryVariables) => ['getAllRadar', variables];
;

useGetAllRadarQuery.fetcher = (client: GraphQLClient, variables: GetAllRadarQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllRadarQuery, GetAllRadarQueryVariables>(client, GetAllRadarDocument, variables, headers);
export const GetRadarDocument = `
    query getRadar($preview: Boolean!, $slug: String!) {
  pages: radarCollection(preview: $preview, where: {slug: $slug}, limit: 1) {
    total
    items {
      title
      quadrant1 {
        ...quadrantFields
      }
      quadrant2 {
        ...quadrantFields
      }
      quadrant3 {
        ...quadrantFields
      }
      quadrant4 {
        ...quadrantFields
      }
    }
  }
}
    ${QuadrantFieldsFragmentDoc}
${BlipFieldsFragmentDoc}
${PersonFieldsFragmentDoc}
${FilterTagFieldsFragmentDoc}
${CapabilityFieldsFragmentDoc}
${RevisionFieldsFragmentDoc}`;
export const useGetRadarQuery = <
      TData = GetRadarQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRadarQueryVariables,
      options?: UseQueryOptions<GetRadarQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetRadarQuery, TError, TData>(
      ['getRadar', variables],
      fetcher<GetRadarQuery, GetRadarQueryVariables>(client, GetRadarDocument, variables, headers),
      options
    );

useGetRadarQuery.getKey = (variables: GetRadarQueryVariables) => ['getRadar', variables];
;

useGetRadarQuery.fetcher = (client: GraphQLClient, variables: GetRadarQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRadarQuery, GetRadarQueryVariables>(client, GetRadarDocument, variables, headers);